module.exports = __webpack_public_path__ + "img/CapeTip200707.5d9ead3f.png";